const form = {
  formId: "new-user-form",
  formField: {
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[1] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    userName:{
      name: "userName",
      label: "[2] Tên người nộp thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    taxId: {
      name: "taxId",
      label: "[3] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    conpanyName: {
      name: "conpanyName",
      label: "[4] Tên đại lý thuế (nếu có)",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên tổ chức cá nhân:",
      invalidMsg: "tên tổ chức cá nhân không hợp lệ",
    },
    conpanytaxId: {
      name: "conpanytaxId",
      label: "[5] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    where: {
      name: "where",
      label: "Địa danh",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa danh",
    },
    releaseDate: {
      name: "releaseDate",
      label: "Ngày Lập",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập ngày lập",
    },
    representative: {
      name: "representative",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
  },
};

export default form;
